import React from "react";
import { usePrice } from "@/components/croc/hooks";
import WalletButton from "@/components/croc/WalletButton";
import { fmtNum } from "@/lib/format";
import { TrendingUp, TrendingDown, Menu } from "lucide-react";

const LOGO = "/logo.png";

export default function Header({ onMenu }) {
  const price = usePrice();
  const up = (price?.change_24h ?? 0) >= 0;

  return (
    <header className="sticky top-0 z-40 glass border-b border-white/10">
      <div className="flex items-center gap-4 px-4 sm:px-6 h-16">
        <button className="lg:hidden text-white" onClick={onMenu} data-testid="mobile-menu-button">
          <Menu className="w-6 h-6" />
        </button>

        <div className="flex items-center gap-2.5">
          <img src={LOGO} alt="CROC" className="w-9 h-9 rounded-lg object-cover" />
          <div className="leading-none hidden sm:block">
            <div className="font-display font-black text-lg tracking-tight text-white">CROC</div>
            <div className="text-[9px] uppercase tracking-[0.28em] gold-text">PROTOCOL</div>
          </div>
        </div>

        {/* Live ticker */}
        <div
          data-testid="croc-usdt-ticker"
          className="ml-2 flex items-center gap-3 rounded-xl border border-white/10 bg-[#090E0B] px-3.5 py-2"
        >
          <span className="w-2 h-2 rounded-full bg-emerald-400 live-dot" />
          <span className="text-xs text-muted-foreground hidden sm:inline">CROC/USDT</span>
          <span data-testid="croc-usdt-ticker-price" className="font-num font-bold text-white">
            ${fmtNum(price?.price, 4)}
          </span>
          <span className={`flex items-center gap-1 text-xs font-num ${up ? "tick-up" : "tick-down"}`}>
            {up ? <TrendingUp className="w-3.5 h-3.5" /> : <TrendingDown className="w-3.5 h-3.5" />}
            {fmtNum(price?.change_24h, 2)}%
          </span>
        </div>

        <div className="ml-auto flex items-center gap-3">
          <div className="hidden md:flex items-center gap-2 rounded-lg border border-white/10 bg-[#090E0B] px-3 py-2">
            <span className="w-2 h-2 rounded-full bg-emerald-400" />
            <span className="text-xs text-muted-foreground">BNB Smart Chain</span>
          </div>
          <WalletButton />
        </div>
      </div>
    </header>
  );
}
